import { fireEvent } from 'utils/generic/event-bus';
import { TBetBuilderModalProps } from 'newcomponents/Shared/sportsbook/BetBuilderModal/types';

export enum EBetBuilderModalActions {
  OPEN_BET_BUILDER_MODAL = 'OPEN_BET_BUILDER_MODAL',
  CLOSE_BET_BUILDER_MODAL = 'CLOSE_BET_BUILDER_MODAL',
  UPDATE_BET_BUILDER_MODAL_PROPS = 'UPDATE_BET_BUILDER_MODAL_PROPS'
}

export const BetBuilderModalActions = {
  open(payload: TBetBuilderModalProps) {
    fireEvent({ key: EBetBuilderModalActions.OPEN_BET_BUILDER_MODAL, payload });
  },

  updateProps(payload: TBetBuilderModalProps) {
    fireEvent({
      key: EBetBuilderModalActions.UPDATE_BET_BUILDER_MODAL_PROPS,
      payload
    });
  },

  close() {
    fireEvent({ key: EBetBuilderModalActions.CLOSE_BET_BUILDER_MODAL });
  }
};
